import { render, staticRenderFns } from "./EditAlternativePage.vue?vue&type=template&id=d311785a"
import script from "./EditAlternativePage.vue?vue&type=script&lang=ts"
export * from "./EditAlternativePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports